"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StudioLogger = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _getEnvVar2 = require("@studio/environment/getEnvVar");
var _browserLogs = require("@datadog/browser-logs");
var _logging = _interopRequireDefault(require("@cvent/logging"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0, _get2["default"])((0, _getPrototypeOf2["default"])(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
/**
 * Studio Logger class extending @cvent/logging Logger
 * @extends Logger
 */
var StudioLogger = exports.StudioLogger = /*#__PURE__*/function (_Logger) {
  /**
   * @param {string} loggerName - Name of the logger
   * @param {Object} [config={}] - Optional configuration object
   */
  function StudioLogger(loggerName) {
    var _getEnvVar;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck2["default"])(this, StudioLogger);
    if (!loggerName) {
      throw new Error('Logger name is required');
    }
    var datadogEnv = (0, _getEnvVar2.getEnvVar)('REACT_APP_CVENT_ENV') || '';
    var datadogApplicationId = (0, _getEnvVar2.getEnvVar)('REACT_APP_DD_RUM_APP_ID') || '';
    var datadogClientToken = (0, _getEnvVar2.getEnvVar)('REACT_APP_DD_RUM_CLIENT_TOKEN') || '';
    var shouldInitDatadogLogs = process.env.NODE_ENV === 'production' && datadogEnv && datadogApplicationId && datadogClientToken;
    var level = ((_getEnvVar = (0, _getEnvVar2.getEnvVar)('LOG_LEVEL')) === null || _getEnvVar === void 0 ? void 0 : _getEnvVar.toLowerCase()) || 'info';
    return _callSuper(this, StudioLogger, [loggerName, _objectSpread(_objectSpread({
      level: level,
      datadog: shouldInitDatadogLogs && _browserLogs.datadogLogs.createLogger(loggerName)
    }, config), {}, {
      forceConsole: true
    })]);
  }

  /**
   * @param {...any} args - Log arguments
   */
  (0, _inherits2["default"])(StudioLogger, _Logger);
  return (0, _createClass2["default"])(StudioLogger, [{
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _superPropGet(StudioLogger, "log", this, 3)(args);
    }

    /**
     * @param {...any} args - Debug arguments
     */
  }, {
    key: "debug",
    value: function debug() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return _superPropGet(StudioLogger, "debug", this, 3)(args);
    }

    /**
     * @param {...any} args - Info arguments
     */
  }, {
    key: "info",
    value: function info() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return _superPropGet(StudioLogger, "info", this, 3)(args);
    }

    /**
     * @param {...any} args - Warning arguments
     */
  }, {
    key: "warn",
    value: function warn() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return _superPropGet(StudioLogger, "warn", this, 3)(args);
    }

    /**
     * @param {...any} args - Error arguments
     */
  }, {
    key: "error",
    value: function error() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
      return _superPropGet(StudioLogger, "error", this, 3)(args);
    }

    /**
     * @param {...any} args - Trace arguments
     */
  }, {
    key: "trace",
    value: function trace() {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }
      return _superPropGet(StudioLogger, "trace", this, 3)(args);
    }
  }]);
}(_logging["default"]);
var _default = exports["default"] = StudioLogger;